import { render, staticRenderFns } from "./ProjectBlock.vue?vue&type=template&id=31d69c45&scoped=true&"
import script from "./ProjectBlock.vue?vue&type=script&lang=js&"
export * from "./ProjectBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBlock.vue?vue&type=style&index=0&id=31d69c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d69c45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
